import PaginationItem from './PaginationItem'

export default PaginationItem
